var React = require('react');

function RedCross (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"7","cy":"7","r":"7","fill":"#EB5757","key":0}),React.createElement("line",{"x1":"4.11589","y1":"10.5939","x2":"9.87755","y2":"3.6799","stroke":"white","key":1}),React.createElement("line",{"x1":"3.85355","y1":"4.03828","x2":"10.2175","y2":"10.4022","stroke":"white","key":2})]);
}

RedCross.defaultProps = {"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none"};

module.exports = RedCross;

RedCross.default = RedCross;
